import CodeView from "@amzn/awsui-code-view-components-console/code-view";
import { CopyToClipboard } from "@amzn/awsui-components-console";
import * as React from "react";

interface CodeViewWithCopyProps {
  content: string;
}

export function CodeViewWithCopy({ content }: CodeViewWithCopyProps) {
  return (
    <>
      <style>{`
        .code-view-with-copy-wrapper .copy-button-container {
          opacity: 0.2;
          transition: opacity 0.2s ease-in-out;
        }
        
        .code-view-with-copy-wrapper:hover .copy-button-container {
          opacity: 1;
        }
      `}</style>
      <div className="code-view-with-copy-wrapper">
        <CodeView
          content={content}
          wrapLines
          actions={
            <div className="copy-button-container">
              <CopyToClipboard
                copyButtonAriaLabel="Copy code"
                copyErrorText="Code failed to copy"
                copySuccessText="Code copied"
                textToCopy={content}
              />
            </div>
          }
        />
      </div>
    </>
  );
}
